

























import Component from "vue-class-component";
import { Vue, Prop, Watch } from "vue-property-decorator";
import { Observer } from "mobx-vue";
import { CollectionEventDetailsModel, getCollectionEventImage, getCollectionEventById, GetCollectionEventImageResponse } from "@/api/CollectionEvents";
import mapStore from "@/store/mapStore";
import CollectionEventDetailsHeader from "@/components/CollectionEvents/CollectionEventDetailsHeader.vue";
import CollectionEventDetailsList from "@/components/CollectionEvents/CollectionEventDetailsList.vue";
import { LoadingStore } from "@/store/loadingStore";
import notificationStore from "@/store/notificationStore";

@Observer
@Component({ components: { CollectionEventDetailsHeader, CollectionEventDetailsList } })
export default class CollectionIssueEventDetailsDialog extends Vue {
  @Prop(Boolean) readonly value: boolean = false;
  @Prop(Number) readonly collectionIssueEventId?: number;
  @Prop(Number) readonly collectionEventType: number | undefined;
  loading = new LoadingStore();
  details: CollectionEventDetailsModel | null = null;
  image: GetCollectionEventImageResponse | null = null;
  mapStore = mapStore;

  async mounted() {
    this.fetchData();
  }

  @Watch("collectionIssueEventId")
  async fetchData() {
    this.loading.track(async () => {
      try {
        if (this.collectionIssueEventId && this.collectionEventType !== undefined) {
          this.image = null;
          this.image = await getCollectionEventImage({ collectionEventId: this.collectionIssueEventId, collectionEventType: this.collectionEventType });
          this.details = await getCollectionEventById({ collectionEventId: this.collectionIssueEventId, isCollectionIssue: true, collectionEventType: this.collectionEventType });
        } else this.details = null;
      } catch (error) {
        notificationStore.error("An unexpected error occurred while loading the issue details");
      }
    });
  }
  close() {
    this.$emit("input", false);
  }
}
